import { render } from "./expertList.vue?vue&type=template&id=28444f3a&scoped=true"
import script from "./expertList.vue?vue&type=script&lang=js"
export * from "./expertList.vue?vue&type=script&lang=js"

import "./expertList.vue?vue&type=style&index=0&id=28444f3a&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28444f3a"]])

export default __exports__